import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "menu" ]

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden");
      this.menuTarget.classList.remove("nav-slide-up");
      this.menuTarget.classList.add("nav-slide-down");
    } else {
      this.menuTarget.classList.add("nav-slide-up");
      this.menuTarget.classList.remove("nav-slide-down");
      setTimeout(() => {
        this.menuTarget.classList.add("hidden");
      }, "300");
    }
  }
}